/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCategoryDto } from '../../models/backend-category-dto';

export interface HandbookCategoriesList$Params {}

export function handbookCategoriesList(
  http: HttpClient,
  rootUrl: string,
  params?: HandbookCategoriesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, handbookCategoriesList.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCategoryDto>>;
    }),
  );
}

handbookCategoriesList.PATH = '/api/handbook/categories/';
